<template>
  <div class="animated fadeIn content-holder">
    <!--Table -->
    <b-card v-if="isTable">
      <b-card-header class="custom-header">
        <div>
          <h5>
            <i class="icon-note"></i> Analytics View / {{ analytic_name }}
          </h5>
        </div>
      </b-card-header>
      <b-card-body v-if="isLoading">
        <spinner></spinner>
      </b-card-body>
      <b-card-body v-else>
        <b-table responsive :fixed="false" :items="items" :fields="fields">
        </b-table>
        <div v-show="!isLoading">
          <b-pagination
            v-model="currentPage"
            :per-page="50"
            :total-rows="resultCount"
            v-on:input="loadNextPage"
          ></b-pagination>
          <div v-if="resultCount > 50">
            Page: {{ currentPage }} of {{ resultCount }}
          </div>
        </div>
      </b-card-body>
    </b-card>
    <!-- mapChart -->
    <b-card v-if="isMapChart">
      <b-row>
        <b-col sm="12">
          <h4 class="card-title mb-0">{{ titleScanonMap }}</h4>
        </b-col>
      </b-row>
      <mapChart class="chart-wrapper" ref="mapchart"> </mapChart>
    </b-card>
    <b-card v-if="isLineChart">
      <b-row>
        <b-col sm="12">
          <h4 class="card-title mb-0">{{ linechart.title }}</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="8"></b-col>
      </b-row>
      <lineChart
        chartId="main-chart-01"
        class="chart-wrapper"
        style="height:300px;margin-top:40px;"
        ref="lineChart"
      ></lineChart>
    </b-card>
    <b-row>
      <b-col md="6" v-if="isSubmitFrom">
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">{{ titleSubmitFrom }}</h4>
            </b-col>
          </b-row>
          <submitFrom ref="submitFrom"> </submitFrom>
        </b-card>
      </b-col>
      <b-col md="6" v-if="isReferrers">
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">{{ titleReferrers }}</h4>
            </b-col>
          </b-row>
          <br />
          <referrers ref="referrers"> </referrers>
        </b-card>
      </b-col>
      <b-col md="6" v-if="isPieChart">
        <b-card>
          <b-row>
            <b-col sm="12">
              <h4 class="card-title mb-0">{{ titlePieChart }}</h4>
            </b-col>
          </b-row>
          <pieChart ref="pieChart"> </pieChart>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import miniToastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { Switch as cSwitch } from "@coreui/vue";
import { router } from "../../router/index";
import vSelect from "vue-select";
import { apigClient } from "@/shared/api";
import moment from "moment";
import "moment-timezone";
import submitFrom from "./components/submitFrom";
import referrers from "./components/referers";
import lineChart from "./components/lineChart";
import mapChart from "./components/mapChart";
import pieChart from "./components/pieChart";
const Spinner = () => import("../shared/Spinner");
const toastTypes = {
  success: "success",
  error: "error",
  info: "info",
  warn: "warn"
};
miniToastr.init({ types: toastTypes });
function toast({ title, message, type, timeout, cb }) {
  return miniToastr[type](message, title, timeout, cb);
}
const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};
Vue.use(VueNotifications, options);
export default {
  name: "Clients",
  components: {
    cSwitch,
    Spinner,
    vSelect,
    mapChart,
    pieChart,
    lineChart,
    submitFrom,
    referrers
  },
  data() {
    let loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    let userTimezone = loginUserInfo.db.timezone || "Asia/Bangkok";
    if (window.location.href.includes("/analytics/view")) {
      var analytic_id = localStorage.getItem("page_analytic_id");
      var analytic_name = localStorage.getItem("page_analytic_name");
    }
    return {
      loginUserInfo: loginUserInfo,
      userTimezone: userTimezone,
      isLoading: false,
      resultCount: 0,
      datasource: "Form",
      currentPage: 1,
      fields: [],
      items: [],
      isTable: false,
      isMapChart: false,
      isLineChart: false,
      isPieChart: false,
      isSubmitFrom: false,
      isReferrers: false,
      isReferer: false,
      analytic_id: analytic_id || null,
      analytic_name: analytic_name || null,
      data: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        fields: [],
        sortable: [],
        filterable: [],
        graph: []
      },
      dataSource_dataColumns: [],
      dataSource_graphTables: [],
      graph: [],
      linechart: {
        title: null,
        count: { value: 15, label: "10" },
        time: {
          value: "days",
          label: "Days",
          format: "DD-MMM-YYYY"
        }
      }
    };
  },
  mounted: function() {
    this.loadConfig();
  },
  computed: {},
  mixins: [validationMixin],
  methods: {
    jsonFormatter: function(obj, target, prefix) {
      let that = this;
      (target = target || {}), (prefix = prefix || "");
      Object.keys(obj).forEach(function(key) {
        if (typeof obj[key] === "object") {
          if (Array.isArray(obj[key])) {
            that.jsonFormatter(obj[key][0] ? obj[key][0] : '.', target, prefix + key + '.');
          } else {
            that.jsonFormatter(obj[key] ? obj[key] : '.', target, prefix + key + '.');
          }
        } else {
          return (target[prefix + key] = obj[key] ? obj[key] : '.');
        }
      });
      return target;
    },
    loadNextPage: function(pageNum) {
      this.isLoading = true;
      this.loadData(pageNum);
    },
    loadConfig: function() {
      var method = "GET";
      var pathTemplate = "/analyticReports/" + this.analytic_id;
      var additionalParams = {};
      var pathParams = {};
      var that = this;
      this.isLoading = true;
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams)
        .then(function(results) {
          if (results.data.status) {
            let data = results["data"]["data"];
            if (
              data.dataSource_dataColumns &&
              data.dataSource_dataColumns.length > 0
            ) {
              that.getTable(
                data.dataSource_dataColumns,
                data.dataOrder,
                data.dataFilter
              );
              that.isTable = true;
              that.datasource = data.dataSource_name.label || "Form";
            }
            if (
              data.dataSource_graphTables &&
              data.dataSource_graphTables.length > 0
            ) {
              data.dataSource_graphTables.map(graph => {
                that.graph.push(graph.value);
              });
            }
            if (
              data.dataSource_name &&
              data.dataSource_name.graphTables &&
              data.dataSource_name.graphTables.length > 0
            ) {
              data.dataSource_name.graphTables.map(graph => {
                that.options.graph.push(graph.value);
              });
            }
            that.loadData(that.currentPage);
          } else {
            that.showErrorMsg({ message: results.data.message });
          }
        })
        .catch(function(error) {
          that.showErrorMsg({ message: error.message });
          that.isLoading = false;
        });
    },
    getTable(datacolumn, dataOrder, dataFilter) {
      this.options.fields = datacolumn.map(column => column.value);
      dataOrder.map(sortable => {
        this.options.sortable.push({
          fieldname: sortable.column_order.value,
          value: sortable.order.value
        });
      });
      dataFilter.map(dataFilter => {
        this.options.filterable.push({
          fieldname: dataFilter.column_filter.value,
          comparisonOperator: dataFilter.condition.value,
          value: dataFilter.value
        });
      });
    },
    loadData(page) {
      if (this.datasource === "Form Submissions") {
        this.options.filterable.push({
          fieldname: "eventType",
          comparisonOperator: "=",
          value: "Form submitted"
        });
      }
      var method = "POST";
      var pathTemplate = "/analytics";
      var additionalParams = {};
      let body = {
        queryParams: {
          datasource: this.datasource,
          filter: this.options.filterable,
          fields: this.options.fields,
          sort: this.options.sortable,
          graph: this.options.graph,
          page: page - 1
        }
      };
      var pathParams = {};
      var that = this;
      apigClient
        .invokeApi(pathParams, pathTemplate, method, additionalParams, body)
        .then(function(results) {
          if (results.data.status) {
            that.resultCount = results["data"]["data"]["count"];
            that.data = results["data"]["data"];
            let itemKey, itemValue, itm = {};
            that.data.results.map(result => {
              let field = that.jsonFormatter(result);
              Object.keys(field).forEach(function(key) {
                itemKey = key;
                itemValue = field[key];
                let data = field[key];
                let index = that.fields.indexOf(key);
                if (index < 0) {
                  that.fields.push(key);
                }
                itm[itemKey] = itemValue;
              });
              that.items.push(itm);
            });
            that.loadChart();
          } else {
            that.showErrorMsg({ message: results.data.message });
          }
          that.isLoading = false;
        })
        .catch(function(error) {
          that.showErrorMsg({ message: error.message });
          that.isLoading = false;
        });
    },
    loadChart() {
      let that = this;
      const graph = that.graph;
      const value = [];
      for (let i = 0; i < graph.length; i++) {
        switch (graph[i]) {
          case "scanonMap":
            that.titleScanonMap = "Scan on Map";
            that.isMapChart = true;
            setTimeout(() => {
              that.$refs.mapchart.initMap(that.data.graph.scanonMap);
            }, 500);
            break;
          case "mostSubmittedForm":
            for (let j = 0; j < that.data.length; j++) {
              value.push(that.data[j].eventTimeStamp);
            }
            that.isLineChart = true;
            that.linechart.title = "Submissions";
            setTimeout(() => {
              that.$refs.lineChart.getChartData(
                that.linechart.count,
                that.linechart.time,
                that.data.graph.submission &&
                  that.data.graph.submission.submission &&
                  that.data.graph.submission.submission.buckets
                  ? that.data.graph.submission.submission.buckets
                  : []
              );
            }, 500);
            break;
          case "submission":
            that.isSubmitFrom = true;
            that.titleSubmitFrom = "Most submitted forms";
            setTimeout(() => {
              that.$refs.submitFrom.getData(that.data.graph.mostSubmittedForm);
            }, 500);
            break;
          case "topReferrers":
            that.isReferrers = true;
            that.titleReferrers = "Top Referrers";
            setTimeout(() => {
              that.$refs.referrers.getData(that.data.graph.topReferrers);
            }, 500);
            break;
          case "scanonCount":
            that.isLineChart = true;
            that.linechart.title = "Scan on Count";
            setTimeout(() => {
              that.$refs.lineChart.getChartData(
                that.linechart.count,
                that.linechart.time,
                that.data.graph.scanonCount &&
                  that.data.graph.scanonCount.scanonCount &&
                  that.data.graph.scanonCount.scanonCount.buckets
                  ? that.data.graph.scanonCount.scanonCount.buckets
                  : []
              );
            }, 500);
            break;
          default:
            console.log("Try looking up for a hint.");
        }
      }
    },
    routerBack() {
      this.$router.go(-1);
    }
  },
  notifications: {
    showSuccessMsgCreate: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The Customer Client data has been create"
    },
    showSuccessMsgUpdate: {
      type: VueNotifications.types.success,
      title: "Operation successfull!",
      message: "The Customer Client data has been update"
    },
    showInfoMsg: {
      type: VueNotifications.types.info,
      title: "Info",
      message: "Here is some info for you"
    },
    showWarnMsg: {
      type: VueNotifications.types.warn,
      title: "Warning",
      message: "That's the kind of warning"
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: null,
      message: ""
    }
  }
};
</script>

<style scoped>
#map {
  height: 32em;
}
</style>

<style lang="scss">
td,
th {
  white-space: nowrap;
}
</style>
